import { allChallenges } from "@mono/allChallenges"
import { TrophyIcon } from "@heroicons/react/24/solid"

export const ChallengeCompletedNotification: React.FC<ChallengeCompletedNotificationProps> = ({ challengeId }) => {
  const challenge = allChallenges.find((c) => c.id === challengeId)

  return (
    <div
      data-testid="notification.challenge-completed"
      className="fixed top-1/2 items-center gap-5 -translate-y-1/2 w-full py-10 font-semibold shadow-centerCardGlow border-amber-400 border-t-4 border-b-4 flex justify-center text-5xl z-20 text-white font-poppins bg-[rgba(0,0,0,0.8)] auction-won-banner-pop-out"
    >
      <div className="flex items-center gap-4">
        <TrophyIcon className="h-12 w-12 text-amber-400" />
        <div className="flex flex-col gap-2">
          <div className="text-3xl uppercase tracking-wider text-amber-400">Challenge Completed</div>
          {challenge ? <div className="text-4xl">{challenge.name}</div> : null}
        </div>
      </div>
    </div>
  )
}
